import type { TestId } from '@repo/test-id';
import { tr } from '@repo/locale';

import PromoCarouselSlide from '@features/promo/components/PromoCarouselSlide';

import phoneRinging from '@assets/images/promo/phone-ringing.webp';
import shield1 from '@assets/images/promo/shield-1.webp';
import shield2 from '@assets/images/promo/shield-2.webp';

interface Props {
  testId: TestId;
}

export default function EntrancePhoneRingingSlide({ testId }: Props) {
  return (
    <PromoCarouselSlide
      title={tr('promo:entrance.phone_ringing.title')}
      points={[
        { label: tr('promo:entrance.phone_ringing.point_1'), isSoon: true },
        { label: tr('promo:entrance.phone_ringing.point_2'), isSoon: true },
        { label: tr('promo:entrance.phone_ringing.point_3'), isSoon: true },
      ]}
      testId={testId}
      theme="orange"
    >
      <img src={phoneRinging} alt="" aria-hidden="true" className="absolute top-18 w-80" />
      <img src={shield1} alt="" aria-hidden="true" className="absolute -top-4 right-10 w-80" />
      <img src={shield2} alt="" aria-hidden="true" className="absolute bottom-0 left-30 w-14" />
    </PromoCarouselSlide>
  );
}
